// Author data for blog posts
// Guest contributors who write about email marketing

export type Author = {
  id: string
  name: string
  role: string
  avatar: string
  /** Public profile URLs for Person JSON-LD `sameAs`. Omit when unverified. */
  sameAs?: Array<string>
}

export const authors: Record<string, Author> = {
  'emma-chen': {
    id: 'emma-chen',
    name: 'Emma Chen',
    role: 'Guest Contributor',
    avatar:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop&crop=face',
  },
  'sofia-martinez': {
    id: 'sofia-martinez',
    name: 'Sofia Martinez',
    role: 'Guest Contributor',
    avatar:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop&crop=face',
  },
  'maya-patel': {
    id: 'maya-patel',
    name: 'Maya Patel',
    role: 'Guest Contributor',
    avatar:
      'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=200&h=200&fit=crop&crop=face',
  },
  'olivia-kim': {
    id: 'olivia-kim',
    name: 'Olivia Kim',
    role: 'Guest Contributor',
    avatar:
      'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=200&h=200&fit=crop&crop=face',
  },
  'ava-johnson': {
    id: 'ava-johnson',
    name: 'Ava Johnson',
    role: 'Guest Contributor',
    avatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=face',
  },
  'brew-team': {
    id: 'brew-team',
    name: 'Brew Team',
    role: 'The Brew Family',
    avatar: '/logo/circle_orange.png',
  },
  'philip-sorensen': {
    id: 'philip-sorensen',
    name: 'Philip Sørensen',
    role: 'Co-founder & CEO, Brew',
    avatar: '/people/philip_sorensen.png',
    sameAs: ['https://www.linkedin.com/in/philipsorensen'],
  },
  'thomas-park': {
    id: 'thomas-park',
    name: 'Thomas Park',
    role: 'Co-founder & CTO, Brew',
    avatar: '/people/thomas_park.jpeg',
    sameAs: ['https://www.linkedin.com/in/thomasjunseopark'],
  },
}

// Helper function to get author by name (case-insensitive, handles spaces)
export function getAuthorByName(name: string | undefined): Author | undefined {
  if (!name) {
    return
  }

  // Convert name to id format (lowercase, spaces to hyphens)
  const nameId = name.toLowerCase().replace(/\s+/g, '-')

  // Try direct lookup first
  if (authors[nameId]) {
    return authors[nameId]
  }

  // Try matching by name
  return Object.values(authors).find(
    (author) => author.name.toLowerCase() === name.toLowerCase()
  )
}
